import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import classNames from 'classnames';
import { isEmpty } from 'ramda';

import { t } from '../../../../../modules/infra/i18n';
import Title from '../../../Title';
import Tooltip from '../../../../common/PortalledTooltip';
import Address from '../../../../common/Address';
import { poLocationList } from '../shapes';

const LocationList = ({
  canEditProducts,
  listItems,
  addressesById,
  shopNamesById,
  goToEditing,
}) => (
  <div className="c-wrapper">
    <Title namespace="po">{t('products:locations.title')}</Title>
    <ReactTable
      data={listItems}
      showPagination={false}
      defaultPageSize={10000}
      minRows={0}
      className={
        classNames('c-table-new',
          { 'c-no-hover': !canEditProducts }
        )
      }
      getTrProps={(_, row) => ({
        onClick: () => canEditProducts && goToEditing(row.original.ownerId),
      })}
      columns={[
        {
          Header: t('products:locations.table.location_header'),
          accessor: 'ownerId',
          Cell: row => shopNamesById[row.value],
          width: 400,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>{t('products:locations.table.po_prefix_header')}</span>
              <Tooltip className="u-type--no-transform">
                {t('products:locations.table.po_prefix_tooltip')}
              </Tooltip>
            </div>
          ),
          accessor: 'prefix',
          Cell: (row) => (row.value === null || isEmpty(row.value)
            ? t('products:locations.table.not_available') : row.value),
          width: 180,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>{t('products:locations.table.po_starting_number_header')}</span>
              <Tooltip className="u-type--no-transform">
                {t('products:locations.table.po_starting_number_tooltip')}
              </Tooltip>
            </div>
          ),
          accessor: 'startingPONumber',
          Cell: (row) => row.value || t('products:locations.table.not_available'),
          width: 180,
        },
        {
          Header: (
            <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
              <span>{t('products:locations.table.bill_to_address_header')}</span>
              <Tooltip className="u-type--no-transform">
                {t('products:locations.table.bill_to_address_tooltip')}
              </Tooltip>
            </div>
          ),
          accessor: 'billingAddressId',
          Cell: row => <Address address={addressesById[row.value]} />,
        },
      ]}
    />
  </div>
);

LocationList.propTypes = {
  canEditProducts: PropTypes.bool.isRequired,
  listItems: poLocationList.isRequired,
  goToEditing: PropTypes.func.isRequired,
  addressesById: PropTypes.object.isRequired,
  shopNamesById: PropTypes.object.isRequired,
};

export default LocationList;
